/**
 * @generated SignedSource<<0dc94f1c6fca2c566f94112ad02eac67>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespMarketplaceStickyHeader_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedContactSellerButton_user" | "PdpSharedMakeOfferButton_user">;
  readonly " $fragmentType": "PdpRespMarketplaceStickyHeader_user";
};
export type PdpRespMarketplaceStickyHeader_user$key = {
  readonly " $data"?: PdpRespMarketplaceStickyHeader_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplaceStickyHeader_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespMarketplaceStickyHeader_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactSellerButton_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedMakeOfferButton_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "d795a8afe2ead64e9278d96eb53c111e";

export default node;
